import { Link } from "react-router-dom";
import { Container } from "@/components/layout/Container";
import { Button } from "@/components/ui/button";

export function NotFound() {
  return (
    <Container size="md" className="py-24 text-center">
      <p className="text-sm font-medium text-brand">404</p>
      <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold tracking-tight">
        Page not found.
      </h1>
      <p className="mt-3 text-text-muted">
        We couldn't find what you were looking for.
      </p>
      <div className="mt-8">
        <Button asChild>
          <Link to="/">Back home</Link>
        </Button>
      </div>
    </Container>
  );
}
